<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>            
            <rkm-col cols="3">
                <rkm-form-select
                    :options="mes"
                    :validations="validations.mes"
                    label="Mês"
                    show-default-option
                    text-field="descricao"
                    v-model="model.mes"
                    value-field="id"
                />
            </rkm-col>
            
            <rkm-col cols="3">
                <rkm-form-select
                    :options="dia"
                    :validations="validations.dia"
                    label="Dia"
                    show-default-option
                    text-field="descricao"
                    v-model="model.dia"
                    value-field="id"
                />
            </rkm-col>
            
            <rkm-col cols="3">
                <rkm-form-select
                    :options="ano"
                    label="Ano"
                    show-default-option
                    defaultOptionText="TODOS"
                    text-field="descricao"
                    v-model="model.ano"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipoId"
                    label="Tipo"
                    show-default-option
                    text-field="descricao"
                    v-model="model.tipoId"
                    :disabled="model.tipoDisabled ? true : false"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="Esse feriado será vinculado nos módulos:"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-group>
                        <rkm-form-checkbox-group
                            v-model="model.modulos"
                        >
                            <rkm-row>
                                <rkm-col
                                    v-for="item in form.modulos"
                                    v-bind:key="item.id"
                                    cols="3"
                                >
                                    <rkm-form-checkbox
                                        :value="item.id"
                                        class="text-nowrap"
                                        inline
                                    >
                                        {{ item.nome }}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-checkbox-group>
                    </rkm-form-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    label="Descrição"
                    v-model="model.observacao"
                    name="observacao"
                    rows="4"
                    max-rows="4"
                    :validations="validations.observacao"
                >
                </rkm-form-textarea>
            </rkm-col>
        </rkm-row>

    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, data} from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                mes: { required: true },
                dia: { required: true },
                tipoId: { required: true },
                observacao: { max: 500, required: true },
            }
        },
        mes() {

            return [
                { 'id': 1, 'descricao': 'JANEIRO'},
                { 'id': 2, 'descricao': 'FEVEREIRO'},
                { 'id': 3, 'descricao': 'MARÇO'},
                { 'id': 4, 'descricao': 'ABRIL'},
                { 'id': 5, 'descricao': 'MAIO'},
                { 'id': 6, 'descricao': 'JUNHO'},
                { 'id': 7, 'descricao': 'JULHO'},
                { 'id': 8, 'descricao': 'AGOSTO'},
                { 'id': 9, 'descricao': 'SETEMBRO'},
                { 'id': 10, 'descricao': 'OUTUBRO'},
                { 'id': 11, 'descricao': 'NOVEMBRO'},
                { 'id': 12, 'descricao': 'DEZEMBRO'},
            ]
            
        },
        dia() {

            return [
                { 'id': 1, 'descricao': '1' },
                { 'id': 2, 'descricao': '2' },
                { 'id': 3, 'descricao': '3' },
                { 'id': 4, 'descricao': '4' },
                { 'id': 5, 'descricao': '5' },
                { 'id': 6, 'descricao': '6' },
                { 'id': 7, 'descricao': '7' },
                { 'id': 8, 'descricao': '8' },
                { 'id': 9, 'descricao': '9' },
                { 'id': 10, 'descricao': '10' },
                { 'id': 11, 'descricao': '11' },
                { 'id': 12, 'descricao': '12' },
                { 'id': 13, 'descricao': '13' },
                { 'id': 14, 'descricao': '14' },
                { 'id': 15, 'descricao': '15' },
                { 'id': 16, 'descricao': '16' },
                { 'id': 17, 'descricao': '17' },
                { 'id': 18, 'descricao': '18' },
                { 'id': 19, 'descricao': '19' },
                { 'id': 20, 'descricao': '20' },
                { 'id': 21, 'descricao': '21' },
                { 'id': 22, 'descricao': '22' },
                { 'id': 23, 'descricao': '23' },
                { 'id': 24, 'descricao': '24' },
                { 'id': 25, 'descricao': '25' },
                { 'id': 26, 'descricao': '26' },
                { 'id': 27, 'descricao': '27' },
                { 'id': 28, 'descricao': '28' },
                { 'id': 29, 'descricao': '29' },
                { 'id': 30, 'descricao': '30' },
                { 'id': 31, 'descricao': '31' },
            ]
            
        },
        ano() {

            let hoje = new Date().getFullYear()
            var ano = []

            for (var i = 0; i <= 9; i++) {
                ano[i] = { 'id': hoje, 'descricao': hoje }
                hoje = hoje + 1
            }

            return ano
            
        },
    },
    created() {

        this.repositories = {
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado')
        }

        this.load()
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.feriado.edit(this.id)
                    .then(({ data }) => {

                        if (data.model) {

                            this.form = this.clone(data.form)
                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.feriado.create()
                    .then(({ data }) => {

                        if (data.model) {

                            this.form = this.clone(data.form)
                            this.model = this.clone(data.model)
                        }

                        this.form.modulos.map(modulo => modulo.id)
                            .forEach(moduloFeriado => {

                                this.model.modulos.push(moduloFeriado)
                        })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.feriado.update(this.id, this.prepareData())
                        : this.repositories.feriado.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            if(this.id) {

                                this.showSaveNotification()
                                this.$emit('save', data)

                            } else {
                                
                                const confirm = async () => {

                                    this.$emit('save', data)
                                }

                                const cancel = async () => {

                                    this.model.ano = null
                                    this.model.mes = null
                                    this.model.dia = null
                                    this.model.tipoId = null
                                    this.model.observacao = null

                                }

                                const msg = 'Registro salvo com sucesso! Deseja voltar para a listagem?'

                                this.showConfirmation(msg, confirm, cancel)
                            }

                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const model = this.clone(this.model)

            model.observacao = this.model.observacao
            model.tipoId = this.model.tipoId,
            model.modulos = this.model.modulos

            return this.camelObjectKeysToSnakeRecursive(model)
        },
    },
    mixins: [ repository, stringCase, object, error, data ],
    props: {
        id: { type: Number }
    },
}
</script>